const awsmobile = {
  "aws_user_pools_web_client_id": "7kvgj7clbf2eqcabs7m0b7k6jq", //This id is referenced at
};


export default awsmobile;
